



























































import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'generalLedgerTable'
})
export default class IncomeAndExpensesDetailTable extends Vue {
  @Prop({ default: () => {} }) public tableDetail: any
  @Prop({ default: '' }) public classNameSelf: string
}
